/* eslint-disable sonarjs/cognitive-complexity */
export default class Range {
  constructor() {
    this.selector = '.c-range';

    this.selectors = {
      slider: '.c-range__slider',
      current: '.c-range__current',
    };

    this.nodes = {};
  }

  bootstrap() {
    const components = [ ...document.querySelectorAll(this.selector) ];

    if (components.length === 0) {
      return;
    }

    components.forEach(component => {
      let values = (component.dataset.values || '').split(',').filter(Boolean);

      values = values.length > 0 ? values : false;

      const slider = component.querySelector(this.selectors.slider);
      const current = component.querySelector(this.selectors.current);

      slider.addEventListener('input', () => {
        const val = slider.value;
        const min = slider.min ? slider.min : 0;
        const max = slider.max ? slider.max : 100;
        const newVal = Number(((val - min) * 100) / (max - min));

        const value = values ? values[val] : val;

        slider.dataset.rangeValue = value;

        current.textContent = value;

        slider.dispatchEvent(
          new CustomEvent('c-range:change', { detail: value }),
        );

        current.style.left = `calc(${newVal}% + (${9 - newVal * 0.15}px))`; // eslint-disable-line no-mixed-operators
      });

      // Initially move the current value
      const val = slider.value;
      const min = slider.min ? slider.min : 0;
      const max = slider.max ? slider.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));

      const value = values ? values[val] : val;

      slider.dataset.rangeValue = value;
      current.textContent = value;

      current.style.left = `calc(${newVal}% + (${9 - newVal * 0.15}px))`; // eslint-disable-line no-mixed-operators
    });
  }
}
